import SEO from "@/components/SEO";
export default function OHAndSPolicyPage() {
  return (
    <div className="min-h-screen bg-white text-black px-6 md:px-20 pt-32 pb-12">
      <SEO
        title="Occupational Health & Safety Policy | VANCO"
        description="VANCO's occupational health and safety policy and our commitment to a safe, healthy workplace."
        path="/ohs-policy"
      />
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-semibold mb-8">
          Occupational Health & Safety Policy
        </h1>

        <p className="mb-4 font-light">
          At VANCO, we are committed to provide safe and healthy working
          conditions for our employees, contractors, visitors, and all
          individuals involved in our operations. Our commitment to OH&S is
          aligned with the purpose, size, and context of our organization, as
          well as the specific nature of our OH&S risks and opportunities.
        </p>

        <h3 className="text-xl font-normal mb-4">1. Key Commitments</h3>

        <ul className="list-disc pl-6 mb-6 space-y-2 font-light">
          <li>
            <strong>Safety and Health Priority:</strong> We prioritize the
            safety and health of our workforce above all else, with a firm
            commitment to preventing work-related injuries and illnesses.
          </li>
          <li>
            <strong>Framework for OH&S Objectives:</strong> We have established
            a framework that guides the setting of OH&S objectives to
            continually enhance occupant&apos;s safety and well-being.
          </li>
          <li>
            <strong>Legal and Other Requirements:</strong> We are dedicated to
            fulfilling all legal requirements and other relevant OH&S
            obligations to ensure compliance with applicable laws and
            regulations.
          </li>
          <li>
            <strong>Hazard Elimination and Risk Reduction:</strong> Our
            commitment extends to the elimination of hazards and the reduction
            of OH&S risks. We actively work to identify and mitigate risks that
            may affect our workforce.
          </li>
          <li>
            <strong>Continual Improvement:</strong> VANCO is unwavering in its
            commitment to the continual improvement of our OH&S management
            system. We strive for ongoing progress in our OH&S practices.
          </li>
          <li>
            <strong>Consultation and Participation:</strong> We encourage and
            value the active consultation and participation of our workers in
            OH&S matters. Workers&apos; representatives, where they exist, are
            also included in this process.
          </li>
          <li>
            <strong>Training & awareness:</strong> VANCO prioritizes training to
            ensure workplace safety. Employees receive induction and periodic
            refresher training on occupation health and safety and emergency
            preparedness. Specialized training is provided for high-risk roles.
            Awareness is reinforced through posters, toolbox talks, and drills.
            Training programs include real-life scenarios, practical
            demonstrations, and interactive sessions. Employee feedback is
            encouraged for continuous improvement.
          </li>
        </ul>

        <h3 className="text-xl font-normal mb-4">2. Roles & Responsibility</h3>

        <ul className="list-disc pl-6 mb-6 space-y-2 font-light">
          <li>
            <strong>Top Management:</strong> Establishes and promotes a strong
            safety culture by integrating OH&S principles into business
            operations. Defines safety objectives, ensures compliance with
            regulatory requirements, and allocates resources to implement
            effective safety measures.
          </li>
          <li>
            <strong>Managers & Supervisors:</strong> Implement safety policies
            and procedures, provide employees with necessary training and
            resources, enforce PPE usage, conduct safety inspections, and take
            corrective actions to address hazards. They actively engage
            employees in safety discussions and initiatives.
          </li>
          <li>
            <strong>Employees & Workers:</strong> Follow established OH&S
            policies, attend training sessions, use protective equipment
            correctly, report unsafe conditions, and participate in workplace
            safety programs. Their commitment ensures a secure and hazard-free
            working environment.
          </li>
          <li>
            <strong>Admin Centre Heads:</strong> Manages policy implementation,
            conducts risk assessments, ensures compliance with legal and
            industry standards, develops safety procedures, investigates
            workplace incidents, facilitates training, oversees emergency
            response planning, and continuously improves safety practices.
          </li>
        </ul>

        <h3 className="text-xl font-normal mb-4">
          3. Grievance Redressal Mechanism
        </h3>

        <p className="mb-4 font-light">
          Grievance Redressal Mechanism: Employees and stakeholders can report
          OH&S concerns and grievances by sending an email to{" "}
          <a href="mailto:info@vanco.ai" className="text-[#243b7f] font-normal">
            info@vanco.ai
          </a>
          . All grievances will be addressed promptly, ensuring transparency and
          corrective actions where necessary.
        </p>

        <h3 className="text-xl font-normal mb-4">
          4. Health & Safety Management System
        </h3>

        <p className="mb-4 font-light">
          The Occupational Health & Safety Management System at VANCO is built
          on the core principles of this policy and fully complies with
          applicable laws and regulations in India. The system and OHS Policy
          are reviewed and updated annually or on need basis to align with
          evolving regulatory requirements, organizational developments, and
          stakeholder expectations.
        </p>

        <p className="mb-4 font-light">
          VANCO actively promotes a culture of safety and well-being by
          encouraging all employees, functions, and business units to uphold the
          principles outlined in this policy. We expect all VANCO team members
          to integrate these Occupational Health & Safety standards into their
          daily work, ensuring a safe and healthy workplace for everyone.
        </p>

        <p className="font-light">
          Our OH&S policy is maintained as documented information, ensuring
          accessibility for all within our organization. We communicate this
          policy throughout our workforce, and as appropriate, to interested
          parties. This policy is relevant and tailored to VANCO&apos;s unique
          OH&S risks and opportunities. This policy represents our dedication to
          fostering a safe and healthy work environment, and we are committed to
          always upholding its principles and objectives.
        </p>
      </div>
    </div>
  );
}
